import script from "./TrainerToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerToggle.vue?vue&type=script&setup=true&lang=js"

import "./TrainerToggle.vue?vue&type=style&index=0&id=7265c9b4&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7265c9b4"]])

export default __exports__